import { Component } from '@angular/core'

@Component({
  selector: 'se-open-registration-card-docs',
  templateUrl: './registration-card-docs.component.html',
  styleUrls: ['./registration-card-docs.component.scss'],
  standalone: false,
})
export class RegistrationCardDocsComponent {}
